import React from 'react';

import { brandColors } from '@/app/constants';
import { RiskFactor } from '@/models/ChurnRisk';

interface RiskFactorsListProps {
  factors: RiskFactor[];
}

const RiskFactorsList: React.FC<RiskFactorsListProps> = ({ factors }) => {
  // Get color based on severity
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'high':
        return brandColors.red;
      case 'medium':
        return brandColors.yellow;
      case 'low':
        return brandColors.green;
      default:
        return brandColors.darkSilver;
    }
  };

  // Sort factors by severity (high first, then medium, then low)
  const getSeverityOrder = (severity: string) => {
    switch (severity) {
      case 'high':
        return 3;
      case 'medium':
        return 2;
      case 'low':
        return 1;
      default:
        return 0;
    }
  };

  const sortedFactors = [...factors].sort((a, b) => getSeverityOrder(b.severity) - getSeverityOrder(a.severity));

  return (
    <ul>
      {sortedFactors.map((factor, index) => (
        <li key={index} className="flex items-center text-custom-darkSilver text-xs mb-2">
          <div className="w-2 h-2 rounded-full mr-2" style={{ backgroundColor: getSeverityColor(factor.severity) }} />
          <span className="mr-2">{factor.description}</span>
          <span className="ml-auto font-semibold capitalize">{factor.severity}</span>
        </li>
      ))}
    </ul>
  );
};

export default RiskFactorsList;
